<template>
  <div class="device-manage">
    <div class="device-manage-content">
      <filter-bar
        :itemArray="itemArray"
        :initialSelectedIndex="selectedComponentIndex"
        :buttonTitle="filterBarButtonTitle"
        keywordTitle="搜索设备SN"
        v-model="keyword"
        @onItemSelected="onItemSelected"
        @onButtonClick="onAddDeviceClick"
        @onSearchClick="onSearchClick"
        @onSearch="onSearch"
        @onExport="onExport"
      />
      <component
        ref="component"
        :is="currentComponent"
        :canDeleteDevice="canDeleteDevice"
        @onAddUserClick="onAddUserClick"
        @onRecycleDeviceClick="onRecycleDeviceClick"
      >
      </component>
    </div>
  </div>
</template>

<script>
import FilterBar from "@c/equipment-file/file/filter-bar.vue";
import File from "@c/equipment-file/file/file.vue";

import { CacheTool } from "@js/cache-tool.js";
export default {
  components: {
    FilterBar,
    File,
   
  },

  data() {
    return {
      selectedComponentIndex: 0,
      keyword: "",
      itemArray: ["监护仪", "监护仪绑定指环", "儿童OSA绑定指环"],
      filterBarButtonTitle: undefined,
      canDeleteDevice: undefined,
    };
  },

  computed: {
    currentComponent() {
      switch (this.selectedComponentIndex) {
        case 0:
          return "file";
        case 1:
          return "file";
        
        default:
          return "";
      }
    },
  },

  async mounted() {
    await this.getLatestUserInfo();
    this.getFilterBarButtonTitle();
    this.canDeleteDevice = this.$store.state.accountInfo.deviceManagement;
  },

  watch: {
    selectedComponentIndex() {
      this.getFilterBarButtonTitle();
    },
  },

  methods: {
    onItemSelected(index) {
      this.selectedComponentIndex = index;
      this.keyword = undefined;
    },

    onSearchClick(keyword) {
      this.$nextTick(() => {
        this.$refs.component.onSearchClick(keyword);
      });
    },

    // 处理筛选搜索
    onSearch(searchConditions) {
      this.$nextTick(() => {
        this.$refs.component.onSearch(searchConditions);
      });
    },
    // 处理导出
    onExport(exportConditions) {
      this.$refs.component.onExport();
    },

    onAddUserClick(selectedModel) {
      this.$emit("onAddUserClick", selectedModel);
    },

    onAddDeviceClick() {
      this.$nextTick(() => {
        this.$refs.component.onAddDeviceClick();
      });
    },

    onRecycleDeviceClick(selectedModel) {
      this.$emit("onRecycleDeviceClick", selectedModel);
    },

    async getFilterBarButtonTitle() {
      if (this.selectedComponentIndex == 2) {
        this.filterBarButtonTitle = null;
      } else {
        this.filterBarButtonTitle = this.$store.state.accountInfo
          .deviceManagement
          ? "新增设备"
          : null;
      }
    },

    async getLatestUserInfo() {
      try {
        const loginInfo = CacheTool.getLoginInfo();
        const params = { id: loginInfo.uid };
        const response = await this.$api.userInfo(params);
        const currentAccountInfo = this.$store.state.accountInfo || {};
        const responseHasAnonymization = Object.prototype.hasOwnProperty.call(
          response,
          "anonymization"
        );
        const nextAccountInfo = {
          ...currentAccountInfo,
          ...response,
          anonymization: responseHasAnonymization
            ? response.anonymization
            : currentAccountInfo.anonymization,
        };
        if (
          nextAccountInfo.deviceManagement == currentAccountInfo.deviceManagement &&
          nextAccountInfo.anonymization === currentAccountInfo.anonymization
        ) {
          return;
        }
        this.$store.commit("saveAccountInfo", nextAccountInfo);
      } catch {}
    },
  },
};
</script>

<style lang="scss" scoped>
.device-manage {
  background-color: #eff2f7;

  &-content {
    background-color: white;
    box-sizing: border-box;
    padding: 0 20px;
    flex: 1;
  }
}
</style>
